import React from 'react';

import { Stack, Typography } from '@mui/material';

import type { SearchPromosByToggleQuery, SearchPromosByToggleResponse } from '~/services/PromoService';

export type PromoByToggleSearchResults = SearchPromosByToggleResponse['result'];

type Props = {
  results?: PromoByToggleSearchResults;
  entity?: SearchPromosByToggleQuery['entity'];
};

/** Displays results returned by {@link PromoByToggle}; it is deliberately separate so callers can place it as needed. */
export default function PromoByToggleResults({ results, entity }: Props) {
  if (!results) {
    return null;
  }

  if (results.length === 0) {
    return (
      <Typography role="status" aria-live="polite">
        No matching {entity ?? 'promo or voucher'} results found.
      </Typography>
    );
  }

  return (
    <Stack spacing={0.5} role="status" aria-live="polite">
      {results.map((result) => (
        <Typography key={result.id}>
          {result.name} ({result.id})
        </Typography>
      ))}
    </Stack>
  );
}
